import React from 'react';
import {
    Create,
    SimpleForm,
    TextInput,
} from 'react-admin';
import withStyles from '@material-ui/core/styles/withStyles';


export const styles = {
    CustomerName: { display: 'inline-block', width: 250, marginLeft: 32, fontSize: '1em' },
};

const redirect = (basePath, id, data) => `/customer`;

const CustomerCreate = ({ ...props }) => (
    <Create {...props}>
        <SimpleForm style={{ width: 900}} redirect={redirect}>
            <TextInput
                label="Name"
                source="CustomerName"/>
        </SimpleForm>
    </Create>
);

export default withStyles(styles)(CustomerCreate);